import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useContext } from 'react';
import { Context } from '../../store/context';
import SearchSharpIcon from '@mui/icons-material/SearchSharp';
import GooglePlacesAutocomplete from './autocomplete';

const Input = styled('input')(() => ({
  border: `1px solid transparent !important`,
  width: '100% ',
  outline: `none !important`,
  height: `35px`,
}));

const InputWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  width: '100%',
  boxSizing: `border-box`,
  height: `48px`,
  padding: `0 20px`,
  borderRadius: `25px`,
  boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
  fontSize: `14px`,
  textOverflow: `ellipses`,
}));
const Wrapper = styled('div')(() => ({
  width: '100%',
}));

function AutoCompleteInput({ isLoaded }) {
  const { map, center, setLastCenter, setLastZoom } = useContext(Context);

  const [placeHolder, setPlaceHolder] = useState();

  const inputRef = useRef();

  const onPlaceChanged = async (place) => {
    if (!place || !place.geometry) {
      return;
    }
    await map.fitBounds(place.geometry.viewport);
    setLastCenter(map.getCenter());
    setLastZoom(map.getZoom());
    inputRef.current.value = '';
  };
  useEffect(() => {
    if (window.innerWidth >= 768) {
      setPlaceHolder('Ingresa tu ubicación o una ubicación de referencia');
    } else {
      setPlaceHolder('Ingresa tu ubicación');
    }
  }, [window.innerWidth]);

  return (
    <>
      <Wrapper>
        {isLoaded === true ? (
          <GooglePlacesAutocomplete
            onPlaceChanged={onPlaceChanged}
            bounds={new window.google.maps.LatLngBounds(center)}
          >
            <InputWrapper>
              <>
                <Input ref={inputRef} type="text" placeholder={placeHolder} />
                <SearchSharpIcon />
              </>
            </InputWrapper>
          </GooglePlacesAutocomplete>
        ) : (
          <></>
        )}
      </Wrapper>
    </>
  );
}

AutoCompleteInput.propTypes = {
  isLoaded: PropTypes.bool,
};

export default AutoCompleteInput;
